import _get from 'lodash/get';

import { Google, GoogleTransformers, Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById, isVDP } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;
/**
 * @summary Sends GA360 and Pixall when clicking on view available offers button
 */
export function inventoryViewAvailableOffersClick(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
    } = metadata;
    const { inventoryId } = data;

    const pageName = _get(dataLayer, 'page.pageName', '');
    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    const inheritPageData = !['vdp'].includes(pageName);
    const inventory = getInventoryOwnerById(state, inventoryId);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);

    Pixall.sendClickEvent({
        eventSource: 'vehicle',
        label: `vw_offers - ${pageId}`,
        inventory,
        pixallData: {
            clickTypeToListingType: isVDP(dataLayer),
        },
    }, dataLayer, option);

    Google.sendClickEvent({
        eventElement: 'partner',
        eventResult: 'text-link::view-available-offers::fair-market-range',
        eventData: {
            vehicle: { ...vehicleData },
        },
    }, option);
    return {};
}
